import { Button, Divider, Popconfirm, Space, Tag, theme } from 'antd';
import { FC } from 'react';
import { BoxArrowUpRight, ExclamationCircle, PencilSquare, Trash } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { CopyableText, DescriptionBlock } from '@/common/components';
import { AppRoutes } from '@/common/interfaces';
import { CommonDrawerTitle } from '@/common/layouts';
import { getDateFactory } from '@/common/utils';

import { Page, PagePublishedAtTag, PageUsageForTag } from '@/modules/Pages';

import { PagesLinkedPagesList } from './PagesLinkedPagesList';

interface Props {
  page: Pick<Page, 'id' | 'title' | 'usageFor' | 'publishedAt' | 'createdAt' | 'updatedAt' | 'previewLink' | 'isPublished'> & {
    structureNode: Pick<Page['structureNode'], 'id' | 'isHome' | 'extension' | 'path' | 'slug'> & {
      site: Pick<Page['structureNode']['site'], 'id' | 'name'>;
      pages: Pick<Page['structureNode']['pages'][0], 'id' | 'title' | 'usageFor'>[];
    };
  };
  disableControlButtons: boolean;
  isDeleteLoading: boolean;
  handleDeletePage: () => void;
}

export const PagesDossierView: FC<Props> = ({ page, disableControlButtons, isDeleteLoading, handleDeletePage }) => {
  const { token } = theme.useToken();
  const { id: pageId, title, createdAt, updatedAt, structureNode, previewLink, usageFor, isPublished, publishedAt } = page;

  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Space>
            <Link to={ AppRoutes.PagesEdit.replace(':siteId', structureNode.site.id).replace(':pageId', pageId) }>
              <Button type="default" icon={ <PencilSquare/> } disabled={ disableControlButtons }/>
            </Link>
            <Popconfirm
              destroyTooltipOnHide
              title="Видалити сторінку"
              icon={ <ExclamationCircle color={ token.colorError }/> }
              description="Ви дійсно хочете видалити цю сторінку?"
              onConfirm={ handleDeletePage }
              okText="Так, видалити"
              okButtonProps={{ danger: true }}
              cancelText="Ні"
              placement="bottomLeft"
              disabled={ disableControlButtons || disableControlButtons }
            >
              <Button
                loading={ isDeleteLoading }
                danger
                type="default"
                icon={ <Trash/> }
                disabled={ disableControlButtons || disableControlButtons }
              />
            </Popconfirm>
          </Space>
        }
      />

      { structureNode.isHome && (
        <>
          <Tag color="blue">Головна</Tag>
          <br/>
          <br/>
        </>
      ) }

      <DescriptionBlock items={ [['Заголовок', title]] }/>

      <DescriptionBlock items={ [['Слаг', structureNode.slug]] }/>

      <DescriptionBlock
        items={ [['Шлях', <CopyableText key="path" textToCopy={ structureNode.path }><Tag>{ structureNode.path }</Tag></CopyableText>]] }/>

      <DescriptionBlock items={ [['Використання для', <PageUsageForTag key="usageFor" value={ usageFor }/>]] }/>

      <DescriptionBlock items={ [['Дата створення', getDateFactory(createdAt, 'Thursday, August 16, 2018 08:02', true)]] }/>

      <DescriptionBlock items={ [['Дата оновлення', getDateFactory(updatedAt, 'Thursday, August 16, 2018 08:02', true)]] }/>

      <DescriptionBlock
        items={ [
          [
            'Статус публікації',
            <PagePublishedAtTag key="page.publishedAt" publishedAt={ publishedAt } isPublished={ isPublished }/>
          ]
        ] }
      />

      <Divider/>

      <Space direction="vertical" className="ant-space-fullwidth" size="large">
        <Button
          target="_blank"
          href={ previewLink }
          type="dashed"
          icon={ <BoxArrowUpRight/> }
          block
          size="large"
          disabled={ disableControlButtons }
        >
          Попереднiй перегляд
        </Button>

        <PagesLinkedPagesList pages={ structureNode.pages } siteId={ structureNode.site.id }/>
      </Space>
    </>
  );
};
